import { ColDef, ICellRendererParams } from "ag-grid-community";
import { MDSignatureComponent } from "./mdsignature.component";
import { CellLinkComponent } from "src/app/common/components/core/table/cell-link.component";
import { AppConstants } from "src/app/common/constants/app-constants";

const caseInsensitiveComparator = (valueA: string, valueB: string): number => {
  const a = (valueA ?? AppConstants.emptyString).trim().toLowerCase();
  const b = (valueB ?? AppConstants.emptyString).trim().toLowerCase();

  if (a === AppConstants.emptyString && b === AppConstants.emptyString) return 0;
  if (a === AppConstants.emptyString) return -1;
  if (b === AppConstants.emptyString) return 1;

  return a.localeCompare(b);
};

export const columnDefinitionMDSignature = (
    component: MDSignatureComponent
  ): ColDef[] => [
    {
      headerName: 'Patient',
      field: 'name',
      headerClass: "text-sm text-center",
      sortable: true,
      suppressMenu: true,
      cellRenderer: CellLinkComponent,
      comparator: caseInsensitiveComparator,
      cellRendererParams: { 
        clicked: component.navigate.bind(component) 
      },
      flex: 2,
    } as ColDef,
    {
        headerName: 'Physician',
        field: 'physicianName',
        headerClass: "text-sm text-center",
        sortable: true,
        suppressMenu: true,
        comparator: caseInsensitiveComparator,
        cellRenderer:  (params: ICellRendererParams) => {
            if (params.value) {
              return `<span title="${params.value}"> ${params.value} <span>`;
            }
            return AppConstants.emDash;
        },
        flex: 2,
      } as ColDef,
    {
      headerName: 'Activity Date',
      field: 'activityDate',
      headerClass: "text-sm text-center",
      cellClass: "text-center",
      sortable: true,
      suppressMenu: true,
      cellRenderer: (params: ICellRendererParams) => {
        if(!!params?.value && params.value != AppConstants.defaultDate){
          const[year, month, date] = params.value.split('-');
          const completeDate = month + "-" + date + "-" + year;
          return `<span title="${completeDate}"> ${completeDate} <span>`
        }
        return AppConstants.emDash
      },
      flex: 2,
    } as ColDef,
    {
      headerName: 'Discipline',
      field: 'discipline',
      headerClass: "text-sm text-center",
      cellClass: "text-center",
      sortable: true,
      suppressMenu: true,
      cellRenderer:  (params: ICellRendererParams) => {
          if (params.value) {
            return `<span title="${params.value}"> ${params.value} <span>`;
          }
          return AppConstants.emDash;
        },
      flex: 1.5,
    } as ColDef,
    {
      headerName: 'Document',
      field: 'documentType',
      headerClass: "text-sm text-center",
      cellClass: "text-center",
      sortable: true,
      suppressMenu: true,
      comparator: caseInsensitiveComparator,
      cellRenderer:  (params: ICellRendererParams) => {
          if (params.value) {
            return `<span title="${params.value}"> ${params.value} <span>`;
          }
          return AppConstants.emDash;
      },
      flex: 2,
    } as ColDef,
    {
        headerName: 'Days In Queue',
        field: 'daysInQueue',
        headerClass: "text-sm text-center",
        cellClass: "text-center",
        sortable: true,
        suppressMenu: true,
        cellRenderer:  (params: ICellRendererParams) => {
            if (params.value) {
              return `<span title="${params.value}"> ${params.value} <span>`;
            }
            return AppConstants.emDash;
        },
        flex: 2,
      } as ColDef,
  ];
  